import { Context, useCallback, useSyncExternalStore } from 'react';
import { useStore, createStoreHook, ReactReduxContextValue } from 'react-redux';

import { StateContext } from '../contexts';

import { CombinedSelector } from './types';

const useAppStore = createStoreHook(
  StateContext as Context<ReactReduxContextValue<any, any>>,
);

const useCombinedSelector = <AppState, RootState, Result>(
  selector: CombinedSelector<AppState, RootState, Result>,
): Result => {
  const appStore = useAppStore();
  const rootStore = useStore();
  const subscribe = useCallback((onChange) => {
    const appUnsubscribe = appStore.subscribe(onChange);
    const rootUnsubscribe = rootStore.subscribe(onChange);

    return () => {
      appUnsubscribe();
      rootUnsubscribe();
    };
  }, []);
  const getSnapshot = useCallback(
    () => selector(appStore.getState(), rootStore.getState()),
    [selector],
  );

  return useSyncExternalStore(subscribe, getSnapshot);
};

export default useCombinedSelector;
